export const primaryColor = "#33d6ff";
export const white = "#FFF";
export const textColor = "#3d3547";
export const textLightColor = "#a7a7a7";
export const background = "#FFF";
export const backgroundLightColor = "#f2f2f2";
